<template>
    <common-fuzzy :param="param" :obj="obj" @change="cb"></common-fuzzy>
</template>

<script>
    import help from '@/util/help'
    export default {
        props: ['obj'],
        data() {
            return {
                param: {
                    api: 'bill/tag/findTagPage',
                    query: {

                    },
                    cols: [
                        {
                            key: 'id',
                            value: '主键',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'tagName',
                            value: '标签名称',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'remark',
                            value: '备注',
                            minWidth: 100,
                            searchNormal: true,
                        },
                    ],
                }
            }
        },
        inject: ['ins'],
        methods: {
            cb(data) {
                help.execFuncByParent(this, 'fuzzyTag', data);
            }
        }
    }
</script>

<style scoped>

</style>
